import { cn } from "@/ds/utils";
import type { ListWithPreviewItemProps } from "@/features/common/components/ListWithPreview";
import type { NotificationModel } from "@/features/notifications/api/models/NotificationModel";
import dayjs from "dayjs";
import { useMemo } from "react";

export type NotificationListItemProps = NotificationModel & ListWithPreviewItemProps;

export const NotificationListItem = (props: NotificationListItemProps) => {
	const {
		created,
		subject,
		message,
		readAt,
		isItemSelected,
		onItemSelected
	} = props;

	const date = useMemo(() => dayjs(created).format("DD MMM YYYY"), [created]);
	const dotColor = useMemo(() => readAt ? "bg-muted" : "bg-primary", [readAt]);

	return (
		<div className={cn("flex flex-col gap-2 p-3 border-b cursor-pointer hover:bg-background-highlight dark:even:hover:bg-background-highlight transition-colors duration-150", isItemSelected ? "bg-background-highlight" : "even:bg-muted/50 dark:even:bg-muted/10")} onClick={onItemSelected}>
			<div className="flex items-center gap-3">
				<div className={cn("min-w-2 min-h-2 max-w-2 max-h-2 rounded-full", dotColor)}></div>
				<div className="type-item truncate min-w-0 grow">{subject}</div>
				<div className="type-meta whitespace-nowrap">{date}</div>
			</div>
			<div className="type-description ml-5">
				{message}
			</div>
		</div>
	);
};
